import {TableDatePicker} from '../function_lib/common_lib';
import './comp_cadet_record_book.css';

export const Comp_CRB_Educational_Rec=(props)=>{
    return(
        <div className="modal fade bd-example-modal-xl"  id="divCRBEducationalRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Cadet Educational Record</h5>
              <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            
           
            <div className="modal-body">
                 {/* form content  */}
                 <div class="steering-certificate">
           
            
           {/* Educational Records */}
          
 <div class="div-6 saperate-page text-start">
        <h5>3.2 Educational Record</h5>
        
        <p><strong>GCE "O" level / Class X</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line11"><input type="text" class="form-control" id="nas_1" name="nas_1" placeholder='Enter name / address of school' /></span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line11"><TableDatePicker refName="date_cert_issue_nas1" /></span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>

            <tr><td class="align-right" colSpan={"2"}><button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-primary">Click to Save (GCE "O" level / Class X)</button></td></tr>
        </table>
        
        <p><strong>GCE "A" level / Class XII</strong></p>
        
        <div class="form-field">
            <span class="field-label">Name and address of the school:</span>
            <span class="input-line"><input type="text" class="form-control" id="nas_2" name="nas_2" placeholder='Enter name / address of school' /></span>
        </div>
        
        <div class="form-field">
            <span class="field-label">Date certificate issued:</span>
            <span class="input-line"><TableDatePicker refName="date_cert_issue_nas2" /></span>
        </div>
        
        <table>
            <tr>
                <th>Subjects</th>
                <th>Grade/ Marks</th>
            </tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr class="empty-row"><td></td><td></td></tr>
            <tr><td class="align-right" colSpan={"2"}><button type="button" onClick={()=>this.saveWappCompaign()} class="btn btn-primary">Click to Save (GCE "A" level / Class XII)</button></td></tr>
        </table>
    </div>

{/* div-7  */}

<div class="div-7 saperate-page text-start">
    <h5>3.3 Professional Training Record</h5>
    <div class="section-title">Cadet's Training Programme</div>
    
   
    <table>
        <tr>
            <th>Pre-Sea Training<br/>Name of the College</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
    
    <table>
        <tr>
            <th>On-Board Training<br/>Name of the Ship</th>
            <th>Date (From)</th>
            <th>Date (To)</th>
        </tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
        <tr class="empty-row"><td></td><td></td><td></td></tr>
    </table>
    
   
    <div class="section-title">Basic Training as Required by STCW 2010- Section A-VI/1</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Personal Survival Techniques</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Fire prevention and Fire fighting</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Elementary First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Personal Safety and Social Responsibilities</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Security Training for persons with designated duties</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
    
   
    <div class="section-title">Record of Other Professional Training</div>
    <table>
        <tr>
            <th>Course</th>
            <th>Date</th>
            <th>Name of Institution</th>
            <th>Location</th>
            <th>Certificate number</th>
        </tr>
        <tr>
            <td>Proficiency in Survival Craft & Rescue Boat</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Radar Observer Course</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Automatic Radar Plotting Aids</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Medical First Aid</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>GMDSS General Operator's Certificate</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Oil and Chemical Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
        <tr>
            <td>Gas Tanker Familiarization</td>
            <td></td><td></td><td></td><td></td>
        </tr>
    </table>
   </div>
        {/* End of Educational Records  */}
            
          
        
        
    
               
            </div>
          
          </div>
          </div>

          </div>
          </div>
    );
}

export default Comp_CRB_Educational_Rec